<template>
  <button :class="{ block: block }" @click="onClick" :disabled="disabled"><slot/></button>
</template>

<style lang="scss" scoped>
button {
  padding: 0.5em 1em;
  border-radius: 3px;
  border: 1px #00dd00 solid;
  background-color: #ffffff;
  box-shadow: 0 1px 5px -3px #000;
  cursor: pointer;

  &.block {
    display: block;
    width: 100%;
  }

  &:disabled {
    border-color: #dddddd;
    color: #cccccc;
    box-shadow: none;
    cursor: not-allowed;
  }
}
</style>

<script>
export default {
  name: 'enlil-button',
  props: {
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick () {
      this.$emit('click')
    }
  }
}
</script>
